import DailyGoals from './DailyGoals'
import GoalsHeader, { WRAP_STYLE } from './GoalsHeader'
import {
  Section,
  SectionTitle,
  HintText,
  TableWrapper,
  Table,
  LabelCell,
  ValueCell,
  MoneyText,
  VALUE_COLUMN_WIDTH,
  LABEL_COLUMN_WIDTH
} from 'pages/Financial/Dre/styles'

const TOTAL_COLUMN_WIDTH = 124

const formatMoney = value => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const formatQuantity = value => Number(value).toLocaleString('pt-BR', { maximumFractionDigits: 2 })

// Como na planilha: só a meta, e célula sem meta em branco para a tabela não virar uma parede de zeros.
function QuantityCell({ cell, kind }) {
  return <ValueCell kind={kind}>{cell.metaQuantity === 0 ? '–' : formatQuantity(cell.metaQuantity)}</ValueCell>
}

function MoneyCell({ cell, kind }) {
  return (
    <ValueCell kind={kind}>
      {cell.metaValue === 0 ? '–' : <MoneyText value={cell.metaValue}/>}
    </ValueCell>
  )
}

// De onde sai a meta: o serviço mais lucrativo (R$ por hora) de cada profissional na especialidade.
function BasisHint({ professionals }) {
  const bases = professionals.filter(professional => professional.basis)

  if (bases.length === 0) return null

  return (
    <HintText>
      Meta pelo serviço mais lucrativo por hora:{' '}
      {bases.map(({ name, basis }) => `${name}: ${basis.serviceName} (${formatMoney(basis.valuePerHour)}/h)`).join(' · ')}
    </HintText>
  )
}

function SpecialtyTable({ specialty, columns }) {
  return (
    <>
      <TableWrapper framed>
        <Table>
          <colgroup>
            <col style={{ width: LABEL_COLUMN_WIDTH }}/>
            {columns.map(column => <col key={column.date} style={{ width: VALUE_COLUMN_WIDTH }}/>)}
            <col style={{ width: TOTAL_COLUMN_WIDTH }}/>
          </colgroup>
          <GoalsHeader title={specialty.name} columns={columns}/>
          <tbody>
            {specialty.professionals.map(professional => (
              <tr key={professional.id}>
                <LabelCell style={WRAP_STYLE}>{professional.name}</LabelCell>
                {columns.map(column => (
                  <QuantityCell key={column.date} cell={professional.cells[column.index]}/>
                ))}
                <QuantityCell kind='total' cell={professional.total}/>
              </tr>
            ))}
            <tr>
              <LabelCell kind='total'>Total</LabelCell>
              {columns.map(column => (
                <QuantityCell key={column.date} kind='total' cell={specialty.cells[column.index]}/>
              ))}
              <QuantityCell kind='total' cell={specialty.total}/>
            </tr>
            <tr>
              <LabelCell kind='total'>Total $</LabelCell>
              {columns.map(column => (
                <MoneyCell key={column.date} kind='total' cell={specialty.cells[column.index]}/>
              ))}
              <MoneyCell kind='total' cell={specialty.total}/>
            </tr>
          </tbody>
        </Table>
      </TableWrapper>
      <BasisHint professionals={specialty.professionals}/>
    </>
  )
}

/*
  "Meta N°": uma tabela por especialidade da categoria escolhida, com as profissionais nas linhas e
  os dias da semana nas colunas, como na planilha. Os serviços da especialidade vêm somados, sem
  dizer qual foi. Cada célula é a meta de atendimentos do dia: a agenda livre da profissional
  preenchida com o serviço mais lucrativo por hora dela na especialidade, no percentual escolhido.
*/
export default function GoalsByQuantity({ year, month, percentage, filter, onFilterChange }) {
  return (
    <DailyGoals
      year={year}
      month={month}
      percentage={percentage}
      filter={filter}
      onFilterChange={onFilterChange}
    >
      {({ category, columns }) => (
        <Section>
          <SectionTitle>{category.name}</SectionTitle>
          {category.specialties.map(specialty => (
            <SpecialtyTable key={specialty.id} specialty={specialty} columns={columns}/>
          ))}
        </Section>
      )}
    </DailyGoals>
  )
}
